interface GreenCircleTickProps {
  size?: number
  className?: string
}

export default function GreenCircleTick({ size = 40, className }: GreenCircleTickProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_65058_28753)">
<path d="M20 40C31.0459 40 40 31.0459 40 20C40 8.95431 31.0459 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0459 8.95431 40 20 40Z" fill="#CBF7D7"/>
<path d="M26.402 13.8378C26.747 13.4065 27.377 13.3365 27.8083 13.6815C28.2395 14.0265 28.3095 14.6565 27.9645 15.0878L18.1169 27.3974C17.7795 27.8191 17.1681 27.8961 16.736 27.5722L11.8122 23.8798C11.3703 23.5484 11.2806 22.9212 11.612 22.4794C11.9433 22.0378 12.5696 21.9482 13.0114 22.2792L17.1589 25.3905L26.402 13.8378Z" fill="#00661D"/>
</g>
<defs>
<clipPath id="clip0_65058_28753">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>

  )
}